
export default {
	install(Vue) {
		/**
		 *去除对象空属性
		 */
		function isEmpty(obj) {
			return (Object.keys(obj).length === 0 && obj.constructor === Object);
		}

		function deleteEmptyString(test, recurse) {

			for (var i in test) {
				if (test[i] === '') {
					delete test[i];
				} else if (recurse && typeof test[i] === 'object') {
					deleteEmptyString(test[i], recurse);
				}
			}
		}
		function deleteEmptyObject(test, recurse) {
			for (var i in test) {
				if (isEmpty(test[i])) {
					delete test[i];
				} else if (recurse && typeof test[i] === 'object') {
					deleteEmptyObject(test[i], recurse);
				}
			}
		}
		// 手机号加密
		Vue.prototype.$maskPhoneNumber = (phone) => {
			if (phone) {
				return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
			} else {
				return ''
			}
		}
		Vue.prototype.deleteEmptyObjectFn = (test, recurse) => {
			deleteEmptyObject(test, recurse);
		};
		/**
		 *传入值，返回时间段
		 */
		Vue.prototype.toLongTime = (n) => {
			var n = n,
				time2 = '',
				d = new Date(),
				year = d.getFullYear(),
				mon = d.getMonth() + 1,
				day = d.getDate(),
				hh = d.getHours(),
				mm = d.getMinutes(),
				ss = d.getSeconds(),
				time1 = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day) + " " + (hh < 10 ? ('0' + hh) : hh) + ":" + (mm < 10 ? ('0' + mm) : mm) + ":" + (ss < 10 ? ('0' + ss) : ss);
			if (day <= n) {
				if (mon > 1) {
					mon = mon - 1;
				}
				else {
					year = year - 1;
					mon = 12;
				}
			}
			d.setDate(d.getDate() - n);
			year = d.getFullYear();
			mon = d.getMonth() + 1;
			day = d.getDate();
			// time2 = year+"-"+(mon<10?('0'+mon):mon)+"-"+(day<10?('0'+day):day)+" "+ (hh<10?('0'+hh):hh) +":"+(mm<10?('0'+mm):mm)+":"+(ss<10?('0'+ss):ss);
			time2 = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day) + " " + "23" + ":" + "59" + ":" + "59";
			return {
				oldDate: time2,
				nowDate: time1
			};
		};
		/**
		 *s随机生成字符串
		 * @returns {string}
		 */
		Vue.prototype.getStr = () => {
			var len = len || 32;
			var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
			var maxPos = $chars.length;
			var pwd = '';
			for (var i = 0; i < len; i++) {
				pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
			}
			return pwd;
		};
		/**
		 *截取字符串
		 * @param str
		 * @param str1
		 */
		Vue.prototype.subStr = (str, str1, str2) => {
			str.match(/【(\S*)】/)[1];
		};
		/**
		 *中国标准时间转换
		 * @param str
		 * @returns 时间数字字符串  如20190329
		 */
		Vue.prototype.ToStrTime = (time) => {
			var day1 = new Date(time);
			day1.setTime(day1.getTime());
			var yy = day1.getFullYear(),
				mm = (day1.getMonth() + 1),
				dd = day1.getDate(),
				hh = day1.getHours(),
				MM = day1.getMinutes(),
				ss = day1.getSeconds();
			if (parseInt(mm) < 10) {
				mm = '0' + mm
			}
			if (parseInt(dd) < 10) {
				dd = '0' + dd
			}

			// console.log(yy+mm+dd);
			return yy + mm + dd;
		};


		/**
		 *中国标准时间转换
		 * @param str
		 * @returns 时间数字字符串  如yyyy-mm-dd hh:mm:ss
		 */
		Vue.prototype.ToStrfommat = (time) => {
			if (time == '') { return ''; }
			var day1 = new Date(time);
			day1.setTime(day1.getTime());
			var yy = day1.getFullYear(),
				mm = (day1.getMonth() + 1),
				dd = day1.getDate(),
				hh = day1.getHours(),
				min = day1.getMinutes(),
				ss = day1.getSeconds();
			if (parseInt(mm) < 10) { mm = '0' + mm }
			if (parseInt(dd) < 10) { dd = '0' + dd }
			if (parseInt(hh) < 10) { hh = '0' + hh }
			if (parseInt(min) < 10) { min = '0' + min }
			if (parseInt(ss) < 10) { ss = '0' + ss }
			// console.log(yy +'-'+mm+'-'+dd+' '+hh+':'+min+':'+ss);
			return yy + '-' + mm + '-' + dd + ' ' + hh + ':' + min + ':' + ss;
		};

		//短：
		Vue.prototype.ToStrfommatShort = (time) => {
			var day1 = new Date(time);
			day1.setTime(day1.getTime());
			var yy = day1.getFullYear(),
				mm = (day1.getMonth() + 1),
				dd = day1.getDate(),
				hh = day1.getHours(),
				min = day1.getMinutes(),
				ss = day1.getSeconds();
			if (parseInt(mm) < 10) { mm = '0' + mm }
			if (parseInt(dd) < 10) { dd = '0' + dd }
			if (parseInt(hh) < 10) { hh = '0' + hh }
			if (parseInt(min) < 10) { min = '0' + min }
			if (parseInt(ss) < 10) { ss = '0' + ss }
			// console.log(yy +'-'+mm+'-'+dd);
			return yy + '-' + mm + '-' + dd
		};


		Vue.prototype.isNullStr = str => {
			if (String(str) === '0') {
				return false
			}
			if (str === null || str === '' || str === undefined) {
				return true
			}
			return false
		}
		/*
		 * @desc   判断是否为手机号
		 * @param  {String|Number} str
		 * @return {Boolean}
		 */
		Vue.prototype.isPhoneNum = str => {
			var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
			if (myreg.test(str)) {
				return true;
			} else {
				return false;
			}
		};

		/**
		 *
		 * @desc  判断是否为身份证号
		 * @param  {String|Number} str
		 * @return {Boolean}
		 */
		Vue.prototype.isIdCard = str => {
			return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(str)
		};
		/**
		 * 时间戳转化成日期格式
		 */
		Vue.prototype.timestampToTime = timestamp => {
			let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
			let Y = date.getFullYear() + '-';
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
			let D = date.getDate() + ' ';
			let h = date.getHours() + ':';
			let m = date.getMinutes() + ':';
			let s = date.getSeconds();
			return Y + M + D + h + m + s;
		};
		/**
		 * 将日期格式转换成时间戳
		 */
		Vue.prototype.timeToTimestamp = time => {
			let timestamp = Date.parse(new Date(time));
			timestamp = timestamp / 1000;
			return timestamp;
		};
		Vue.prototype.setStorage = (key, val) => {
			window.sessionStorage.setItem(key, val);
		}
		Vue.prototype.getHeight = () => {
			return window.screen.height;
		}
		Vue.prototype.getStorage = name => {
			if (!name) return;
			return window.sessionStorage.getItem(name);
		};
		Vue.prototype.removeStorage = name => {
			if (!name) return;
			return window.sessionStorage.removeItem(name);
		};
		/*
		* 数组转字符串
		* */
		Vue.prototype.arrayVariableString = name => {
			// return name.join(",")
			// return namer.join("")
			return name.toString()
		};

		/***
		 * 操作系统中接口返回'yyyy-MM-dd HH:mm:ss'格式的时间字符串
		 * 转换为yyyy-MM-dd
		 * @param dateStr
		 * @returns {*}
		 */
		Vue.prototype.optTime = dateStr => {
			if (dateStr) {
				return dateStr.split(' ')[0]
			}
			return ''
		}
		/***
		 * 操作获取当前日期的前n天/后n天
		 * @param num 第n天
		 * @param separator 分隔符
		 * @returns {string}
		 */
		Vue.prototype.getDay = (num, separator) => {
			const today = new Date();
			const nowTime = today.getTime();
			const ms = 24 * 3600 * 1000 * num;
			today.setTime(parseInt(nowTime + ms));
			const oYear = today.getFullYear();
			let oMoth = (today.getMonth() + 1).toString();
			if (oMoth.length <= 1) oMoth = '0' + oMoth;
			let oDay = today.getDate().toString();
			if (oDay.length <= 1) oDay = '0' + oDay;
			return oYear + separator + oMoth + separator + oDay;
		}
		/* 
			用于全局时分的方法
		*/
		Vue.prototype.getTimeMinutes = () => {
			var timeMinutes = new Date();
			var getHours = timeMinutes.getHours()
			var getMinutes = timeMinutes.getMinutes()
			getHours = getHours < 10 ? '0' + getHours : getHours;
			getMinutes = getMinutes < 10 ? '0' + getMinutes : getMinutes;
			var times = getHours + ":" + getMinutes;
			return times;
		}
		//邮箱验证
		Vue.prototype.checkEmail = (email) => {
			var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
			if (!reg.test(email)) {
				return false
			}
			else {
				return true
			}
		}

		// 获取当前日期的前n天，后n天的日期
		Vue.prototype.getDateStr = (AddDayCount) => {
			var dd = new Date();
			dd.setDate(dd.getDate() + AddDayCount);//获取AddDayCount天后的日期    
			var y = dd.getFullYear();
			var m = dd.getMonth() + 1;//获取当前月份的日期    
			var d = dd.getDate();
			return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d);
		}

		// 处理号码为空
		Vue.prototype.Trim = function (str) {
			var result;
			result = str.replace(/(^\s+)|(\s+$)/g, "");
			result = result.replace(/\s/g, "");
			return result;
		}

		//验证微信

		Vue.prototype.checkWechat = (wechat) => {
			var reg = new RegExp("^[a-zA-Z][a-zA-Z0-9_-]{5,19}$");
			if (!reg.test(wechat)) {
				return false
			}
			else {
				return true
			}
		}
		// 防抖函数
		/**
		 * @param {Function} func     
		 * @param {number} wait         等待时间
		 * @param {boolean} immediate   是否立刻触发回调
		 * @return {*}
		 */
		Vue.prototype.debounce = function (func, wait, immediate) {
			let timeout, args, context, timestamp, result;

			const later = function () {
				// 据上一次触发时间间隔
				let last = Number(new Date()) - timestamp;

				// 上次被包装函数被调用时间间隔last小于设定时间间隔wait
				if (last < wait && last > 0) {
					timeout = setTimeout(later, wait - last);
				} else {
					timeout = null;
					// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
					if (!immediate) {
						result = func.call(context, ...args, context);
						if (!timeout) {
							context = args = null;
						}
					}
				}
			};
			//闭包
			return function (..._args) {
				context = this;
				args = _args;                           //事件参数数组
				timestamp = Number(new Date());         //当前时间
				const callNow = immediate && !timeout;
				// 如果延时不存在，重新设定延时
				if (!timeout) {
					timeout = setTimeout(later, wait);
				}
				if (callNow) {
					result = func.call(context, ...args, context);
					context = args = null;
				}

				return result;
			};
		};
		//防止按钮在短时间多次点击
		// 用法：：<button v-intervalclick='{func:执行方法,time:间隔时间(毫秒数),...执行方法所需要的参数}'>点击</button> 
		let openDelay = false;
		Vue.directive('intervalclick', function (el, binding) {
			el.onclick = function (e) {
				if (openDelay) return;
				openDelay = !openDelay;
				if (!binding.value) {
					alert("未传入Value数据！");
					return;
				}
				let func = binding.value['func'];
				let time = binding.value['time'];
				if (typeof time !== 'number') {
					alert("传入等待时间错误");
					return;
				}
				let args = [];
				for (const key in binding.value) {
					if (binding.value.hasOwnProperty(key)) {
						if (key === 'func' || key === 'time') continue;
						args.push(binding.value[key])
					}
				}
				setTimeout(() => {
					openDelay = !openDelay;
				}, time);
				func(...args);
			}
		})
	}
}
